import React, { useEffect, useState } from 'react';
import './CourseDetails.css';
import CourseEditModal from './CourseEditModal';


export default function CourseDetails({ title }) {
  const [details, setDetails] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // ← Neu

  useEffect(() => {
    if (!title) return;

    fetch(`http://localhost/App/backend-web/get_course_details.php?title=${encodeURIComponent(title)}`)
      .then(res => res.json())
      .then(data => setDetails(data));
  }, [title]);

  const refresh = () => {
    fetch(`http://localhost/App/backend-web/get_course_details.php?title=${encodeURIComponent(title)}`)
      .then(res => res.json())
      .then(data => setDetails(data));
  };

  if (!details.length) return null;

  return (
    <div className="course-details">
      <h3>Aktuelle Termine für: {title}</h3>
      <table>
        <thead>
          <tr>
            <th>Datum von</th>
            <th>Zeit</th>
            <th>Raum</th>
            <th>Dozent</th>
            <th>Ort</th>
            <th>Anwendung</th>
            <th>Beschreibung</th>
            <th>Link</th>
          </tr>
        </thead>
        <tbody>
          {details.map((row, i) => (
            <tr key={i} onClick={() => setSelectedRow(row)} style={{ cursor: 'pointer' }}>
              <td>{row.course_date_from}</td>
              <td>{row.course_time}</td>
              <td>{row.course_location}</td>
              <td>{row.course_lecturer}</td>
              <td>{row.course_origin}</td>
              <td>{row.course_application}</td>
              <td>{row.course_description || '–'}</td>
              <td>
                {row.course_link ? (
                  <a href={row.course_link} target="_blank" rel="noreferrer">Plattform</a>
                ) : '–'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedRow && (
        <CourseEditModal
          data={selectedRow}
          onClose={() => setSelectedRow(null)}
          onSave={refresh}
        />
      )}
    </div>
  );
}
